import React from 'react'
import MutedText from './muted-text'

type InputHelpTextProps = {
  content: string,
}

function InputHelpText({ content }: InputHelpTextProps) {
  return (
      <MutedText as="div" className="pt-1" style={{ fontSize: '0.8rem' }}>
        {content}
      </MutedText>
    )
}

export default InputHelpText
